<template>
    <div>
        <div class="checkout__card" v-show="OrderId === ''">
            <div v-if="!isMobile" class="account__border">
                <div class="account__card--topbar py-2 account__card--topbar--padding d-flex justify-content-between align-items-center">
                    <div v-if="creditCardIssuer === 'UNKNOWN'" class="text--green font-weight-bold">Creditcard</div>
                    <div v-else class="text--green font-weight-bold" v-text="creditCardIssuer"></div>
                    <div v-if="creditCardIssuer === 'MASTERCARD'" style="width: 60px">
                        <checkout-payment-credit-card-logo :credit-card-issuer="creditCardIssuer"></checkout-payment-credit-card-logo>
                    </div>
                    <div v-else style="width: 70px">
                        <checkout-payment-credit-card-logo :credit-card-issuer="creditCardIssuer"></checkout-payment-credit-card-logo>
                    </div>
                </div>
            </div>
            <div v-if="isFetchingCreditCards">
                <div class="row">
                    <div class="col my-4 text-center">
                        <img class="mx-auto" style="height: 25px;" src="/themes/brekz-2017/img/loading-indicator-l.gif">
                        <b class="ml-1 my-auto">{{ $t("checkout.loading") }}</b>
                    </div>
                </div>
            </div>
            <div v-if="isMobile" class="checkout__creditcard--wrapper-title text-center py-3">
                <span>{{ $t("checkout.lastStep") }}</span>
            </div>
            <div class="account__card--inner">
                <div v-if="!isMobile && userCards.length > 0 && showSavedCreditCards" class="account__border pb-4">
                    <div class="pt-3 pb-2 checkout--grey-text">{{ $t("checkout.savedCard", {card: 'creditcard'}) }}</div>
                    <div class="row mb-1" v-for="userCard in userCards">
                        <div class="col-6">
                            <div @click="handleSelectedCard(userCard.key, userCard.paymentMethod)" class="d-flex align-items-center checkout__mini-card">
                                <input class="mr-2" :checked="userCard.key === selectedCard" type="radio" value="">
                                <div class="checkout__mini-card--text mr-2">{{ $t("checkout.cardNumber") }}&nbsp;</div>
                                <div class="checkout__mini-card--text">{{ styleDescription(userCard.description) }}</div>
                                <div class="ml-auto py-2 px-2" style="width: 70px"><checkout-payment-credit-card-logo :credit-card-issuer="userCard.paymentMethod"></checkout-payment-credit-card-logo></div>
                                <i @click="deleteCard(userCard)" class="checkout__mini-card--delete fas fa-trash"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isMobile && userCards.length > 0">
                <swipe-list
                    ref="list"
                    class="card"
                    :items="userCards"
                    item-key="id"
                    v-if="showSavedCreditCards"
                >
                    <template v-slot="{ item, index, revealLeft, revealRight, close }">

                        <div class="account__card--inner d-flex align-items-center checkout__selector">
                            <div @click="(selectedCard = item.key) && (handleSelectedCard(item.key, item.paymentMethod))" class="d-flex align-items-center w-100 checkout--grey-text">
                                <input class="mr-2 cursor-pointer" :checked="item.key === selectedCard" type="radio" value="">
                                <div class="checkout__mini-card--text mr-2">{{ $t("checkout.cardNumber") }} </div>
                                <div class="mr-2 checkout__mini-card--text">{{ styleDescription(item.description) }}</div>
                                <div class="ml-auto px-2" style="width: 70px">
                                    <checkout-payment-credit-card-logo :credit-card-issuer="item.paymentMethod"></checkout-payment-credit-card-logo>
                                </div>
                            </div>
                            <i @click="revealRight(index)" class="ml-3 swipeout-action fas fa-trash" style="color: #E5E5E5;"></i>
                        </div>
                        <div class="checkout--spacer"></div>

                    </template>
                    <template v-slot:right="{ item }">
                        <div>
                            <div @click="deleteCard(item)" class="swipeout-action bg-danger px-5 d-flex" style="height: 56px">
                                <i class="fa fa-trash my-auto text--white"></i>
                            </div>
                            <div class="checkout--spacer"></div>
                        </div>
                    </template>
                </swipe-list>
                <div v-if="!useNewCard" @click="createNewCard" class="account__card--inner checkout__selector d-flex align-items-center">
                    <div class="d-flex align-items-center">
                        <input class="mr-2" type="radio" value="">
                        <div>{{ $t("checkout.otherCard", {card: 'creditcard'}) }}</div>
                    </div>
                </div>
            </div>

            <div v-show="!isFetchingCreditCards" class="account__card--inner">
                <div v-if="userCards.length > 0">
                    <div v-if="!isMobile" class="pt-3 pb-2 checkout--grey-text">{{ $t("checkout.newCard", {card: 'creditcard'}) }}</div>
                    <div v-if="!useNewCard && !isMobile" class="row">
                        <div class="col-12 col-md-6">
                            <div @click="createNewCard" class="d-flex align-items-center checkout__mini-card text--green py-2 mb-2">
                                <i class="fas fa-plus mr-2"></i>
                                <div>{{ $t("checkout.addNewCard", {card: 'creditcard'}) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6 push-lg-6 checkout__creditcard--wrapper pt-3">
                        <div v-show="useNewCard">
                            <p v-if="!savePaymentDetails && isMobile" class="checkout__creditcard--wrapper-title text-center">{{ $t("checkout.lastStep") }}</p>
                            <div class="d-flex justify-content-center">
                                <div class="checkout__creditcard p-3">
                                    <div class="pb-2 d-flex justify-content-between align-items-center">
                                        <div style="width: 50px;height: 50px;background-color: #e5e5e5;border-radius: 8px"></div>
                                        <div style="width:80px;">
                                            <checkout-payment-credit-card-logo :credit-card-issuer="creditCardIssuer"></checkout-payment-credit-card-logo>
                                        </div>
                                    </div>
                                    <div class="row checkout__creditcard--text">
                                        <div class="col-12">
                                            <label class="checkout__creditcard--label">{{ $t("checkout.cardNumber") }}</label>
                                            <div class="checkout__creditcard--text overflow-hidden checkout__creditcard--letterspacing" v-text="creditcardCode"></div>
                                        </div>
                                        <div class="col-8">
                                            <label class="checkout__creditcard--label">{{ $t("checkout.name") }}</label>
                                            <div class="checkout__creditcard--text text-uppercase overflow-hidden text-nowrap" v-text="cardHolderName"></div>
                                        </div>
                                        <div class="col-4">
                                            <label class="checkout__creditcard--label">{{ $t("checkout.expireDate") }}</label>
                                            <div class="checkout__creditcard--text overflow-hidden" v-text="expirationDate"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-lg-6 pull-lg-6 pt-3"
                    :class="[ useNewCard ? '' : 'checkout--large-spacer checkout--border-top-media']">
                        <div v-show="useNewCard"
                             class="px-3">
                            <div class="row mb-3">
                                <div class="col-12">
                                    <div class="mb-1 text--md-sm">{{ $t("checkout.cardNumber") }}</div>
                                    <input type="text"
                                           :class="{ 'input--error': !isValidCard }"
                                           class="input py-2"
                                           placeholder="XXXX XXXX XXXX XXXX"
                                           maxlength="19"
                                           @focus="isValidCard = true"
                                           @blur="validateCardNumber"
                                           @keyup="updateCreditCardName"
                                           @keyup.left="buttonPressLeft"
                                           @keyup.right="buttonPressRight"
                                           id="creditcardNumber"
                                           ref="creditcardNumber">
                                    <small v-if="!isValidCard"
                                           class="text-danger">{{ $t("checkout.errorCard") }}</small>
                                </div>
                            </div>


                            <div class="row mb-3">
                                <div class="col-12">
                                    <div class="mb-1 text--md-sm">{{ $t("checkout.name") }}</div>
                                    <input type="text"
                                           :class="{ 'input--error': !isValidCardHolderName }"
                                           class="input py-2"
                                           :placeholder="$t('checkout.cardHolderNamePlaceholder')"
                                           maxlength="22"
                                           v-model="cardHolderName"
                                           @focus="isValidCardHolderName = true"
                                           @blur="validateCardHolderName"
                                           @keyup.left="buttonPressLeft"
                                           @keyup.right="buttonPressRight"
                                           id="creditcardNameHolder"
                                           ref="creditcardNameHolder">
                                    <small v-if="!isValidCardHolderName"
                                           class="text-danger">{{ $t("checkout.errorName") }}</small>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="mb-1 text--md-sm">{{ $t("checkout.expireDate") }}</div>
                                    <input
                                        type="text"
                                        :class="{ 'input--error': !isValidExpirationDate }"
                                        class="input py-2"
                                        placeholder="12/24"
                                        maxlength="5"
                                        @focus="isValidExpirationDate = true"
                                        @blur="validateExpirationDate"
                                        @keyup="updateCreditCardDate"
                                        @keyup.left="buttonPressLeft"
                                        @keyup.right="buttonPressRight"
                                        id="creditcardExpireDate"
                                        ref="creditcardExpireDate"
                                    >
                                    <small
                                        v-if="!isValidExpirationDate"
                                        class="text-danger">
                                        {{ $t("checkout.errorDate") }}
                                    </small>
                                </div>

                                <div class="col-6">
                                    <div class="mb-1 text--md-sm">CVV <span @click="showHelpCvv = true"><i class="fas fa-question-circle ml-2 text--gray-100"></i></span></div>
                                    <input type="text"
                                           :class="{ 'input--error': !isValidCvv }"
                                           class="input py-2"
                                           placeholder="123"
                                           maxlength="3"
                                           v-model="creditcardCVV"
                                           @focus="isValidCvv = true"
                                           @blur="validateCardCvv"
                                           @keyup="updateCreditCardCVV"
                                           @keyup.left="buttonPressLeft"
                                           @keyup.right="buttonPressRight"
                                           id="creditcardCVV"
                                           ref="creditcardCVV">
                                    <small v-if="!isValidCvv" class="text-danger">{{ $t("checkout.errorCVV") }}</small>
                                </div>
                            </div>

                            <div :class="[ !useNewCard ? '': 'account__border mt-4 w-100']">

                            </div>
                        </div>
                        <div class="px-3">
                            <div class="d-flex align-items-center"
                                 :class="[ useNewCard ? 'mt-3' : 'checkout--border' ]">
                                <div class="mr-1 font-weight-bold">{{ $t("checkout.total") }}</div>
                                <div class="text--sm text--gray-100">{{ $t("checkout.taxIncl") }}</div>
                                <div v-for="cart in cartArray" class="ml-auto text--lg text--green"><strong>{{cart.total}}</strong></div>
                            </div>
                            <div class="d-flex mt-2" v-if="useNewCard">
                                <label class="toggle-switch mr-2 mt-1">
                                    <input class="toggle-switch--input"
                                           name="save_payment_details"
                                           v-model="savePaymentDetails"
                                           type="checkbox">
                                    <span class="toggle-switch--slider round"></span>
                                </label>
                                <div style="font-size: 0.9rem">
                                    {{ $t("checkout.saveCard", {card: $t("checkout.creditCard")}) }}
                                    <span class="text--gray-100"> &nbsp;{{ $t("checkout.nextTime") }}</span></div>

                            </div>

                            <input type="hidden" name="creditcard_type" v-model="creditCardIssuer">
                            <input type="hidden" name="ciphertext" value="">
                        </div>


                    </div>
                </div>
            </div>
            <div class="py-4 account__card--bottom-bar align-items-center"
                 :class="[!isMobile ? 'checkout--border-top mt-3' : '']">
                <img v-if="isSubmitting"
                     alt="Submitting..."
                     class="mr-auto"
                     style="height: 25px;"
                     src="/themes/brekz-2017/img/loading-indicator-l.gif">
                <button class="button button--clear checkout__cancel-button m-0 hidden-sm-down"
                        @click="cancelPayment()"
                        :disabled="isSubmitting">{{ $t("checkout.cancel") }}</button>
                <button type="submit"
                        :disabled="isSubmitting || !allInputValid || isFetchingCreditCards"
                        @click="savePaymentDetails ? saveCreditCard() : startPayment()"
                        name="submitPaymentMethod"
                        class="button-brekz button-brekz--rounded button-brekz--yellow button-brekz--xl w-100-sm m-0 d-flex">
                    <span class="ml-auto mr-md-auto">{{ $t("checkout.order") }}</span>
                    <i class="fas fa-chevron-right my-auto ml-auto d-md-none"></i>
                </button>
            </div>
            <button class="button button--clear m-0 hidden-md-up mt-2 mb-4 mx-3"
                    @click="cancelPayment()">
                <div class="d-flex align-items-center text--md-sm">
                    <i class="fas fa-chevron-left mr-3 text--green"></i>{{ $t("checkout.back") }}
                </div>
            </button>
        </div>

        <div id="iframe-area" class="checkout__iframe" v-show="OrderId !== ''">
        </div>

        <div v-show="OrderId !== '' && hasIFrame" class="px-5 py-3 text--green text-center">
            Not loading after 20 seconds? Please contact Brekz customer service <i>(your order ID is: {{ OrderId }})</i> or check your order status IN A NEW TAB.
        </div>

        <div v-show="hasIFrame === false" class="py-4" id="proceedWaiting">
            <h2 class="text--green text-center">{{ $t("checkout.processWaiting.title")}}</h2>
            <p class="text-center mt-4">{{ $t("checkout.processWaiting.description")}}</p>

            <div class="proceedWaiting__loading-box">
                <div class="loading-dots">
                    <div class="loading-dots__wrapper">
                        <div class="loading-dots__item"></div>
                        <div class="loading-dots__item"></div>
                        <div class="loading-dots__item"></div>
                        <div class="loading-dots__item"></div>
                        <div class="loading-dots__item"></div>
                    </div>
                </div>
            </div>
        </div>

        <modal-vue title=":("
                   :show="showErrorModal"
                   @close="showErrorModal = false"
                   :buttons='[{text: "Oke", class: "button-brekz button-brekz--rounded button-brekz--yellow button--extra-large", emit_name: "close"}]'>
            <p class="my-3">{{ errorModalContent }}</p>
        </modal-vue>

        <modal-vue :title='$t("checkout.paymentSucces")'
                   :show="showPaymentCompletedModal"
                   width="xs">
            <p class="my-3">{{ $t("checkout.paymentSucces") }}</p>
            <p class="mb-2">{{ $t("checkout.backToOrderhistory") }}</p>
            <div class="d-flex justify-content-center"><i class="fal fa-check-circle fa-5x text--green mb-3"></i></div>
        </modal-vue>



        <modal-vue title='CVV code'
                   :show="showHelpCvv"
                   @close="showHelpCvv = false"
                   :buttons='[{text: this.$i18n.t("checkout.close"), class: "mx-auto button-brekz button-brekz--rounded button-brekz--green button-brekz--xl", emit_name: "close"}]'
                   width="xs">
            <div class="p-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 316">
                    <g id="Layer_2" data-name="Layer 2">
                        <g id="Layer_1-2" data-name="Layer 1">
                            <g id="Back_credit_card" data-name="Back credit card">
                                <g id="Group_348" data-name="Group 348">
                                    <rect id="Rectangle_266" data-name="Rectangle 266" style="fill: #757575;" width="500"
                                          height="316" rx="43.24"/>
                                    <path id="Subtraction_2" data-name="Subtraction 2" style="fill: #f3f3f3;"
                                          d="M456.76,316H43.24A43.24,43.24,0,0,1,0,272.76V79H500V272.76A43.24,43.24,0,0,1,456.76,316ZM493.67,21H6.27A43.09,43.09,0,0,1,43.17,0H456.78a43.06,43.06,0,0,1,36.89,21Z"/>
                                    <g id="_1234_5678_9876_5432" data-name=" 1234 5678 9876 5432" class="cls-3" style="isolation: isolate;">
                                        <text style="isolation: isolate;font-size: 33.84px;letter-spacing: 0.12em;fill: #707070;font-family: SegoeUI, Segoe UI;" transform="matrix(-1, 0, 0, 1, 462.42, 203.39)">1234 5678 9876
                                            5432
                                        </text>
                                    </g>
                                    <rect id="Rectangle_265" data-name="Rectangle 265" style="fill: #fff;" x="24" y="104"
                                          width="361" height="55"/>
                                    <g id="_123" data-name=" 123" class="cls-3" style="isolation: isolate;">
                                        <text style="isolation: isolate;fill: #707070;font-family: SegoeUI, Segoe UI;font-size: 26.32px;letter-spacing: 0.12em;" transform="translate(327.06 141.35)">123</text>
                                    </g>
                                    <g id="Ellipse_52" data-name="Ellipse 52">
                                        <ellipse class="cls-7" style="fill: none;" cx="355.26" cy="128.19" rx="63.92" ry="54.52"/>
                                        <ellipse class="cls-8" style="fill: none;stroke: green;stroke-width: 4px;" cx="355.26" cy="128.19" rx="60.16" ry="50.76"/>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
        </modal-vue>

    </div>
</template>

<script>
import 'vue-swipe-actions/dist/vue-swipe-actions.css';
import { SwipeList, SwipeOut } from 'vue-swipe-actions';
import { handleThreeDsAuthentication } from "../js/docdata";
import ModalVue from "./ModalVue";
import CheckoutPaymentCreditCardLogo from './CheckoutPaymentCreditcardLogo';
import Cleave from 'cleave.js';
import axios from "axios";

export default {
        components: {
            CheckoutPaymentCreditCardLogo,
            SwipeOut,
            SwipeList,
            ModalVue
        },
        props: {
            moduleLink: {
                type: String,
                required: true
            },
            checkoutLink: {
                type: String,
                required: true
            },
            checkoutCancelPaymentLink: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                windowWidth: '',
                selectedCard: null,
                paymentMethod: 'MASTERCARD',
                userCards: [],
                cartArray: [],
                showSavedCreditCards: true,
                isFetchingCreditCards: false,
                creditcardCode: '',
                cardHolderName: null,
                expirationDate: '',
                creditcardCVV: '',
                OrderId: '',
                paymentStatusTimer: '',
                paymentOrderKey: '',
                hasIFrame: null,
                savePaymentDetails: true,
                creditCardIssuer: '',
                isSubmitting: false,
                useNewCard: false,
                showErrorModal: false,
                showHelpCvv: false,
                reloadPageAfterClosingModal: false,
                errorModalContent: '',
                showPaymentCompletedModal: false,
                inputElements: [
                    'creditcardNumber',
                    'creditcardNameHolder',
                    'creditcardExpireDate',
                    'creditcardCVV'
                ],
                invalidInputElements: [],
                isValidCardHolderName: true,
                isValidExpirationDate: true,
                isValidCard: true,
                isValidCvv: true,
                isTouchedCardHolderName: false,
                isToucheddExpirationDate: false,
                isTouchedCard: false,
                isTouchedCvv: false,
            };
        },
        methods: {
            isIFrameEmpty() {
                const  iframe =  document.getElementById('Authentication');

                if  (! iframe){
                    this.hasIFrame = false;
                    return;
                }

                this.hasIFrame = true;
            },
            cancelPayment() {
                window.location.href = this.checkoutCancelPaymentLink;
            },
            isInputInvalid(elementReference) {
                const result = this.invalidInputElements.find((item) => {
                    return item === elementReference;
                });

                if (result === undefined) {
                    return false;
                }

                // Can only be invalid once
                this.invalidInputElements.splice(this.invalidInputElements.indexOf(elementReference), 1);
                return true;
            },
            cardTypeChanged: function(type) {
                this.creditCardIssuer = type.toUpperCase();
                this.paymentMethod    = type.toUpperCase();
            },
            isTouched: function () {

            },
            validateCardHolderName: function () {
                if (!this.cardHolderName) {
                    return this.isValidCardHolderName = false;
                }
                if (this.cardHolderName.length < 3) {
                    return this.isValidCardHolderName = false;
                }
                if (this.isInputInvalid('creditcardNameHolder')) {
                    return this.isValidCardHolderName = false;
                }

                this.isValidCardHolderName = true;
            },
            validateExpirationDate: function () {
                if (!this.expirationDate) {
                    return this.isValidExpirationDate = false;
                }
                if (this.expirationDate.length !== 5) {
                    return this.isValidExpirationDate = false;
                }

                const dateNow             = new Date();
                dateNow.setMonth(dateNow.getMonth() - 1); // Allow expiration dates in the current month

                const splitExpirationDate = this.expirationDate.split('/');
                const dateCard = new Date(parseInt('20' + splitExpirationDate[1]), parseInt(splitExpirationDate[0]) - 1);

                this.isValidExpirationDate = (dateCard > dateNow);
            },
            validateCardNumber: function ()  {
                if (!this.creditcardCode) {
                    return this.isValidCard = false;
                }
                if (this.creditcardCode.length !== 19) {
                    return this.isValidCard = false;
                }
                if (! this.creditCardIssuer || this.creditCardIssuer === 'UNKNOWN'){
                    return this.isValidCard = false;
                }
                if (this.isInputInvalid('creditcardNumber')) {
                    return this.isValidCard = false;
                }

                this.isValidCard = true;
            },
            validateCardCvv: function() {
                if (!this.creditcardCVV) {
                    return this.isValidCvv = false;
                }
                if (this.creditcardCVV.length < 3) {
                    return this.isValidCvv = false;
                }
                if (isNaN(this.creditcardCVV)) {
                    return this.isValidCvv = false;
                }
                if (this.isInputInvalid('creditcardCVV')) {
                    return this.isValidCvv = false;
                }

                this.isValidCvv = true;
            },
            createNewCard() {
                this.useNewCard = true;
                this.selectedCard = null;
                this.savePaymentDetails = true;
            },
            saveCreditCard() {
                if (!this.allInputValid) return;

                const formData        = new FormData();
                const ciphertext      = this.getCardCipher();

                formData.set('card_cipher', ciphertext);
                formData.set('card_type', this.paymentMethod);
                formData.set('createToken', null);

                this.isSubmitting = true;

                axios.post(this.moduleLink, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then((response) => {
                    if (!response.data.success) {
                        this.isSubmitting = false;
                        this.errorModalContent = this.$t('checkout.errorModalText') + "\n" + this.$t('checkout.errorModalText2');
                        this.showErrorModal = true;
                        return;
                    }

                    if  (response.data.redirectUrl) {
                        window.location.href = response.data.redirectUrl;
                    }

                    if (response.data.ddpTokenKey.key) {
                        this.paymentMethod = response.data.paymentMethod
                        this.startPayment();

                        this.userCards = response.data.customerSavedCards ? response.data.customerSavedCards : [];
                    }
                }).catch((error) => {
                    let code = "UNKNOWN_CODE";
                    console.error("FOUND ERROR in SaveCreditcard module: ", error)
                    if (error && error.response) {
                        code = error.response.data.error.code;
                    }

                    this.invalidInputElements = [];

                    if (code.includes('INVALID_CARD_NUMBER') || code.includes('INVALID_CARDNUMBER')){
                        this.invalidInputElements.push('creditcardNumber');
                    }

                    if (code.includes('INVALID_EXPIRY_DATE') && code.includes('INVALID_EXPIRYDATE')) {
                        this.invalidInputElements.push('creditcardExpireDate');
                    }

                    if (code.includes('INVALID_CARD_NAME') || code.includes('ERROR_CARDHOLDERNAME_MISSING')){
                        this.invalidInputElements.push('creditcardNameHolder');
                    }

                    this.validateCardNumber();
                    this.validateCardHolderName();
                    this.validateExpirationDate();
                    this.validateCardCvv();
                    this.isSubmitting = false;
                });
            },
            submitForm(path, params, method='post') {

                const form = document.createElement('form');
                form.method = method;
                form.action = path;

                params = params.parameter;

                for(var key in params) {
                    var hiddenField = document.createElement("input")
                    hiddenField.setAttribute('type', "hidden")
                    hiddenField.setAttribute('name', params[key].name)
                    hiddenField.setAttribute('value', params[key]['_'])
                    form.appendChild(hiddenField);
                }

                document.body.appendChild(form);
                form.submit();
            },
            startPayment() {
                const formData = new FormData();
                formData.set('startPayment', null);

                const ciphertext = this.getCardCipher();
                formData.set('card_cipher', ciphertext);
                formData.set('card_type', this.paymentMethod);
                if  (this.selectedCard){
                    formData.set('ddp_token_key', this.selectedCard);
                }

                let GAClientId = null;
                let GASessionId = null;
                if (typeof window.getGAClientId === 'function' && typeof window.getGASessionId === 'function') {
                    GAClientId = window.getGAClientId();
                    GASessionId = window.getGASessionId();
                }
                formData.set('ga_client_id', GAClientId);
                formData.set('ga_session_id', GASessionId);

                this.isSubmitting = true;

                axios.post(this.moduleLink, formData, {headers: { 'Content-Type': 'multipart/form-data' } })
                     .then(response => {
                        this.isSubmitting = false;

                        if (!response.data.success) {
                            if (response.data.redirectUrl) {
                                return window.location.href = response.data.redirectUrl;
                            }

                            let code = response.data.error.code ?  response.data.error.code : 'CREDITCARD_NO_CODE';
                            this.errorModalContent = this.$t('checkout.errorModalText') + "\n" + `ERROR: ${code}` + "\n" + this.$t('checkout.errorModalText2');
                            this.showErrorModal = true;
                            return;
                        }

                         if (response.data.redirectUrl) {
                             this.hasIFrame          = false;
                             this.OrderId            = response.data.order_id;
                             this.paymentOrderKey    = response.data.redirectUrl.paymentClusterKey;
                             this.paymentStatusTimer = setInterval(() => {
                                 this.isIFrameEmpty();
                                 this.getOrderStatus();
                             }, 3000);


                             if (Array.isArray(response.data.redirectUrl.redirects)) {
                                 response.data.redirectUrl.redirects.forEach(redirect => {

                                     if (redirect.purpose === 'HIDDEN_IFRAME') {
                                         this.createHiddenIframeAndSubmitForm(redirect.url, redirect.method, redirect.parameters);
                                     } else {
                                         setTimeout(() => handleThreeDsAuthentication(redirect.url, redirect.parameters, true, response.data.redirectUrl.paymentClusterKey, this), 3000);
                                     }
                                 });
                                 return;
                             }

                             if (response.data.redirectUrl.redirects.purpose === "REDIRECT") {
                                 this.submitForm(response.data.redirectUrl.redirects.url, response.data.redirectUrl.redirects.parameters, response.data.redirectUrl.redirects.method);
                             } else {
                                 handleThreeDsAuthentication(response.data.redirectUrl.redirects.url, response.data.redirectUrl.redirects.parameters, true, response.data.redirectUrl.paymentClusterKey, this);
                             }


                         } else {
                             this.showPaymentCompletedModal = true;

                             setTimeout(() => {

                                 response.data.redirectUrl ? window.location.href = response.data.redirectUrl : "";

                             }, 3000);
                         }
                })
                     .catch((error => {
                         let code = "UNKNOWN_CODE";
                         console.error("FOUND ERROR in StartPayment: ", error)
                         if (error && error.response) {
                            code = error.response.data.error ? error.response.data.error.code : null;
                         }

                        if (code === "UNKNOWN_CODE"){
                            if (error && error.response) {
                                code = error.response.data.code;
                            }
                        }

                        if  (code.includes('UNKNOWN_ERROR')) {
                            this.getCreditCards();
                            return;
                        }

                        this.invalidInputElements = [];

                        if (code.includes('ERROR_INVALID_CARDNUMBER') || code.includes('INVALID_CARDNUMBER') || code.includes('ERROR_START_PAYMENT_INVALID_CARD_NUMBER')) {
                            return this.invalidInputElements.push('creditcardNumber');
                        }

                        if (code.includes('INVALID_EXPIRY_DATE') && code.includes('INVALID_EXPIRYDATE')) {
                            return this.invalidInputElements.push('creditcardExpireDate');
                        }

                        if (code.includes('INVALID_CARD_NAME') || code.includes('INVALID_CARDNAME') || code.includes('MISSING_CARD_HOLDER')) {
                            return this.invalidInputElements.push('creditcardNameHolder');
                        }

                        if (code === "TOKEN_EXPIRED"){
                            this.selectedCard = 'id';
                            this.useNewCard = true;
                            this.savePaymentDetails = true;

                            this.getCreditCards();

                            this.showErrorModal = true;
                            this.errorModalContent = this.$t('checkout.cardExpired');
                            return;
                        }

                        if (error.response.data.forceReload) {
                            this.reloadPageAfterClosingModal = true;
                        }

                        if (error.response.data.redirectUrl) {
                            return window.location.href = response.data.redirectUrl;
                        }

                        this.validateCardNumber();
                        this.validateCardHolderName();
                        this.validateExpirationDate();
                        this.validateCardCvv();

                        this.errorModalContent = this.$t('checkout.errorModalText') + "\n" + `ERROR: ${code}` + "\n" + this.$t('checkout.errorModalText2');
                        this.showErrorModal = true;
                        this.isSubmitting = false;
                }))

            },
            createHiddenIframeAndSubmitForm(url, method, parameters) {
                let hiddenIframe = document.createElement('iframe');
                hiddenIframe.src = "about:blank"
                hiddenIframe.style.display = 'none';
                hiddenIframe.id = "hiddenFrame";
                hiddenIframe.name = "hiddenFrame";

                document.body.appendChild(hiddenIframe);

                const idocument = hiddenIframe.contentWindow.document;
                const submitForm = idocument.createElement("form");
                submitForm.setAttribute("target", "hiddenFrame");
                submitForm.setAttribute("method", method);
                submitForm.setAttribute("action", url);

                for(var key in parameters) {
                    var hiddenField = idocument.createElement("input")
                    hiddenField.setAttribute('type', "hidden")
                    hiddenField.setAttribute('name', parameters[key].name)
                    hiddenField.setAttribute('value', JSON.stringify(parameters[key]))
                    submitForm.appendChild(hiddenField);
                }

                const browser_info = {};
                browser_info.java_enabled = navigator.javaEnabled();
                browser_info.java_script_enabled = true;
                browser_info.language = navigator.language;
                browser_info.color_depth = screen.colorDepth;
                browser_info.screen_height = screen.height;
                browser_info.screen_width = screen.width;
                browser_info.time_zone_offset = new Date().getTimezoneOffset();
                browser_info.challenge_window_size = '05';

                hiddenField = idocument.createElement("input")
                hiddenField.setAttribute('type', "hidden")
                hiddenField.setAttribute('name', 'browser_info')
                hiddenField.setAttribute('value', JSON.stringify(browser_info))
                submitForm.appendChild(hiddenField);


                hiddenIframe.appendChild(submitForm);
                submitForm.submit();

            },
            getOrderStatus() {
                if (!this.OrderId || this.showPaymentCompletedModal) {
                    return;
                }
                const formData = new FormData();

                formData.set('order_id', this.OrderId);
                formData.set('key', this.paymentOrderKey);
                formData.set('getPaymentStatusCreditCard', null);

                axios.post(this.moduleLink, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                     .then(response => {

                         const data = response.data;

                         if (data.paymentStatus.paymentComplete) {
                             clearInterval(this.paymentStatusTimer);

                             this.showPaymentCompletedModal = true;

                             data.redirectUrl ? window.location.href = data.redirectUrl : "";

                         } else if (data.paymentStatus.paymentCanceled){
                             clearInterval(this.paymentStatusTimer);

                             data.redirectUrl ? window.location.href = data.redirectUrl : "";
                         }

                     })
                     .catch(error => {
                         console.log(error);
                     })
            },
            getCardCipher(){
              const cardCode        = this.creditcardCode.replace(/\s+/g, '');
              const splitDates      = this.expirationDate.split('/');
              const expirationYear  = splitDates[1];
              const expirationMonth = splitDates[0];
              return   window.cseEncrypt(this.cardHolderName, cardCode, expirationMonth, expirationYear, this.creditcardCVV);
            },
            getCreditCards() {
                this.isFetchingCreditCards = true;

                axios.get(this.moduleLink, {
                    params: {
                        payment_type: 'CREDITCARD'
                    }
                })
                     .then((response) => {
                         this.userCards             = response.data.currentTokens ? response.data.currentTokens : [];
                         this.isFetchingCreditCards = false;
                         if (this.userCards.length === 0) {
                             this.useNewCard = true;
                         } else if (this.userCards.length === 1) {
                             this.handleSelectedCard(this.userCards[0].key, this.userCards[0].paymentMethod)
                         }
                     })
                     .catch((error) => {
                         this.showErrorModal = true;

                     });
            },
            getCart() {
                axios.get('/module/brekz_my_account_api/cart?action=get')
                     .then((response) => {
                         this.cartArray = response.data;
                     })
                     .catch((error) => {

                     });

            },
            handleSelectedCard(id, paymentMethod){
                this.selectedCard       = id;
                this.paymentMethod      = paymentMethod;
                this.useNewCard         = false;
                this.savePaymentDetails = false;
            },
            buttonPressLeft(element) {
                const elementTarget = element.target;
                const cursorPosition = elementTarget.selectionStart;

                if (cursorPosition === 0) {
                    this.goToPreviousInput(elementTarget.id);
                }
            },
            buttonPressRight(element) {
                const elementTarget = element.target;
                const cursorPosition = elementTarget.selectionStart;

                if (cursorPosition === elementTarget.maxLength || elementTarget.id === "creditcardNameHolder") {
                    this.goToNextInput(elementTarget.id);
                }
            },
            goToPreviousInput(currentInputRef) {
                let inputElementIndex = -1;

                this.inputElements.forEach((value, index) => {
                    if (value === currentInputRef) {
                        inputElementIndex = index;
                    }
                });

                if (inputElementIndex === -1 || inputElementIndex === 0) {
                    return;
                }

                let newSelectedInputElement = this.$refs[this.inputElements[inputElementIndex - 1]];
                newSelectedInputElement.select();
                newSelectedInputElement.selectionStart = newSelectedInputElement.value.length;
                newSelectedInputElement.selectionEnd = newSelectedInputElement.value.length;
            },
            goToNextInput(currentInputRef) {
                let inputElementIndex = -1;

                this.inputElements.forEach((value, index) => {
                    if (value === currentInputRef) {
                        inputElementIndex = index;
                    }
                });

                if (inputElementIndex === -1 || (inputElementIndex === this.inputElements.length - 1 && currentInputRef !== "creditcardNameHolder")) {
                    return;
                }

                let newSelectedInputElement = this.$refs[this.inputElements[inputElementIndex + 1]];
                newSelectedInputElement.select();
                newSelectedInputElement.selectionStart = 0;
                newSelectedInputElement.selectionEnd = 0;
            },
            deleteCard(card) {
                const formData = new FormData();
                const cardKey = card.key;

                formData.set('ddp_token_key', cardKey);
                formData.set('deleteToken', null);
                formData.set('payment_type', 'CREDITCARD');

                this.isFetchingCreditCards = true;
                this.showSavedCreditCards = false;

                axios.post(this.moduleLink, formData).then(response => {
                    this.userCards             = response.data.currentTokens ? response.data.currentTokens : [];
                    this.selectedCard          = this.userCards.length === 0 ? null : this.handleSelectedCard(this.userCards[0].key, this.userCards[0].paymentMethod);
                    this.isFetchingCreditCards = false;
                    this.showSavedCreditCards  = true;

                    if (this.userCards.length === 0) {
                        this.useNewCard = true;
                    }

                }).catch(error => {
                    this.isFetchingCreditCards = false;
                    this.showSavedCreditCards = true;
                    this.showErrorModal = true;
                    this.errorModalContent = "Er is iets fout gegaan tijdens het verwijderen van de kaart";
                })
            },
            updateCreditCardName() {
                this.creditcardCode = this.cleaveCreditCardNumber.getFormattedValue();
            },
            updateCreditCardDate() {
                this.expirationDate = this.cleaveCreditCardDate.getFormattedValue();
            },
            updateCreditCardCVV() {
                this.creditcardCVV = this.cleaveCreditCardCVV.getFormattedValue();
            },
            styleDescription(description){
                let clearDescription = description.toString().substring(12);

                return " *** " + clearDescription;
            }
        },
        computed: {
            isMobile() {
                return this.windowWidth <= 767
            },
            allInputValid: function () {
                if (this.selectedCard !== null && !this.useNewCard){
                    return true
                }

                if (!this.isEmptyField){
                    return this.isValidCard &&
                        this.isValidCvv &&
                        this.isValidCardHolderName &&
                        this.isValidExpirationDate;
                }

            },
            isEmptyField() {
                return !this.cardHolderName || !this.creditcardCVV || !this.creditcardCode || !this.expirationDate;

            }
        },
        watch: {
            showErrorModal(newValue){
                if (! newValue && this.reloadPageAfterClosingModal) {
                    location.reload();
                }
            }
        },
        mounted() {
            this.getCreditCards();
            this.getCart();
            this.windowWidth = window.innerWidth;

            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth
            });

            this.cleaveCreditCardNumber = new Cleave(this.$refs.creditcardNumber, {
                creditCard: true,
                onCreditCardTypeChanged: this.cardTypeChanged
            });

            this.cleaveCreditCardDate = new Cleave(this.$refs.creditcardExpireDate, {
                date: true,
                datePattern: ['m', 'y']
            });

            this.cleaveCreditCardCVV = new Cleave(this.$refs.creditcardCVV, {
                numeral: true,
                numeralIntegerScale: 3,
                stripLeadingZeroes: false
            });
        }
    };
</script>
<link href="https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap" rel="stylesheet">
